<template>
  <div style="padding-bottom: 50px;">
    <a-config-provider :locale="zhCN">
      <router-view />
    </a-config-provider>
    <div class="layout-footer">
      <span @click="toPlat">监管服务平台</span>
      <span style="margin-left: 30px;" @click="toBeian">网络备案号：苏ICP备2021007623号-2</span>
      <span style="margin-left: 30px;" @click="toCompany">技术支持：南京智慧交通信息股份有限公司</span>
    </div>
  </div>
</template>
<script setup lang="ts">
import zhCN from "ant-design-vue/es/locale/zh_CN";
import { getGlobalSetting } from "@/globalSetting";

const toPlat = () => {
  window.open(getGlobalSetting().manageUrl, "_blank")
}
const toBeian = () => {
  window.open("http://beian.miit.gov.cn/", "_blank");
}
const toCompany = () => {
  window.open('https://www.jsniti.com/', '_blank')
}
</script>
<style lang="less">
body {
  //background: #000938 url('@/views/assets/bg.jpg');
  //background-size: cover;
  width: 100%;
  height: 100vh;
  background-color: #F0F0F0;
  margin: 0;
}

a {
  text-decoration: none;
  color: #60B4F1;
}

a:hover {
  color: #b1dfff;
}

ul,
li {
  list-style: none;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  //text-align: center;
  //color: #2c3e50;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.layout-footer {
  position: fixed;
  width: 100%;
  height: 40px;
  background-color: #fff;
  bottom: 0;
  left: 0;
  text-align: center;
  line-height: 40px;
  font-size: 12px;
  z-index: 99999;

  span {
    cursor: pointer;
    color: #999;

    &:hover {
      color: #000;
    }
  }
}
</style>
